export class Tag {
  public id: string;
  public name: string;

  constructor(data: Partial<Tag> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: Partial<Tag> = {}): Tag {
    return new Tag(data);
  }
}
